module.exports = __webpack_public_path__ + "static/img/2.623f30f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/2.png
// module id = MxaQ
// module chunks = 1